export type FeedbackDto = {
    value: FeedbackValues
    comment?: string
}

export enum FeedbackValues {
    WILL_WORK_WITH_AGAIN = 'WILL_WORK_WITH_AGAIN',
    WILL_NOT_WORK_WITH_AGAIN = 'WILL_NOT_WORK_WITH_AGAIN',
    MIGHT_WORK_WITH_AGAIN = 'MIGHT_WORK_WITH_AGAIN',
    DO_NOT_KNOW_THEM = 'DO_NOT_KNOW_THEM',
    HIDDEN = 'HIDDEN',
}
